import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'; 
import { KnBrUploadNewTemplateDialogComponent } from 'src/app/sales-libs/kn-br-nac/components/kn-br-upload-new-template-dialog/kn-br-upload-new-template-dialog.component';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { FormErrorsComponent } from '@spartacus/storefront';
import { SimpleFileUploadComponent, FilesAcceptDirective } from '@iplab/ngx-file-upload';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'knbr-sloan-upload-new-template-dialog',
    templateUrl: './sloan-upload-new-template-dialog.component.html',
    styleUrls: ['./sloan-upload-new-template-dialog.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, FormErrorsComponent, SimpleFileUploadComponent, FilesAcceptDirective, TranslatePipe]
})
export class SloanUploadNewTemplateDialogComponent extends KnBrUploadNewTemplateDialogComponent implements OnInit {
  constructor(
    protected activeModal: NgbActiveModal,
    protected fb: FormBuilder,
    protected sloanCommonService: KnBrCommonService
  
  ) {
    super(activeModal, fb, sloanCommonService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  upload() {
    if (this.uploadTemplateForm.valid && this.fileUploadControl.value.length > 0) {
      const formData: FormData = new FormData();
      formData.append('attachment', this.fileUploadControl.value[0]);
      this.sloanCommonService.createNacTemplate(this.uploadTemplateForm.controls.templateName.value, formData);
      this.activeModal.close(this.uploadTemplateForm.value);
    } else {
      this.uploadTemplateForm.markAllAsTouched();
    }
  }
}
